<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Készlet transzformációk</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/processes/stock-transformations/add')"
        icon="el-icon-plus"
        v-can="'stocktransformation.create'"
      >
        Új készlet transzformáció
      </el-button>
    </div>
    <!--<div v-loading="loading" style="min-height: 81px;">-->
      <!--&lt;!&ndash;<table-filter&ndash;&gt;-->
        <!--&lt;!&ndash;v-if="filterConfig"&ndash;&gt;-->
        <!--&lt;!&ndash;:config="filterConfig"&ndash;&gt;-->
        <!--&lt;!&ndash;action="declutter/fetchAll"&ndash;&gt;-->
      <!--&lt;!&ndash;/>&ndash;&gt;-->
    <!--</div>-->
    <stock-transformation-list/>
    <template v-if="$route.meta.showAddStockTransformationDialog">
      <stock-transformation-dialog
        type="add"
      />
    </template>
  </el-card>
</template>

<script>
  import StockTransformationList from '../../components/processes/stockTransformations/List';
  import StockTransformationDialog from '../../components/processes/stockTransformations/Dialog';
  // import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      StockTransformationDialog,
      StockTransformationList,
      // TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/storages'];
        let users = this.$store.getters['user/users'];
        let currencies = this.$store.getters['currency/currencies'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        if(!currencies.length) {
          await this.$store.dispatch('currency/fetchAll');
          currencies = this.$store.getters['currency/currencies'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'reference_number',
            label: 'Hivatkozási szám',
          },
          {
            type: 'text',
            name: 'comment',
            label: 'Megjegyzés',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Teljesített',
                status: 'completed'
              },
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Érvénytelenítve',
                status: 'cancelled'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: storages,
            name: 'source_storage_id',
            label: 'Raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: currencies,
            name: 'currency_id',
            label: 'Deviza',
            labelCallback: currency => currency && currency.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'creator_user_id',
            label: 'Rögzítette',
            labelCallback: user => user && user.last_name +' '+ user.first_name|| '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'completing_user_id',
            label: 'Teljesítette',
            labelCallback: user => user && user.last_name +' '+ user.first_name|| '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>

